import React from 'react';
import { Redirect, Stack } from 'expo-router';
import { observer } from '@legendapp/state/react';
import { globalState } from '@/state/globalState';
import { canAccessChecklistSettings } from '@/utils/userRoles';

function ChecklistsSettingsLayout() {
  const userType = globalState.user.profile.get()?.user_type;

  if (!canAccessChecklistSettings(userType)) {
    return <Redirect href="/(app)/settings" />;
  }

  return (
    <Stack initialRouteName="index">
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen name="ordering" options={{ headerShown: false }} />
      <Stack.Screen name="fields" options={{ headerShown: false }} />
      <Stack.Screen name="templates" options={{ headerShown: false }} />
    </Stack>
  );
}

export default observer(ChecklistsSettingsLayout);
